import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { InversionistasService } from '../services/inversionistas.service';
import { SucursalesService } from '../services/sucursales.service';
import { HelpersService } from '../services/tools/helpers.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-inversionistas',
  templateUrl: './inversionistas.component.html',
  styleUrls: ['./inversionistas.component.scss']
})
export class InversionistasComponent implements OnInit, OnDestroy {

  // Variables de Estado y Listados
  public inversionistas: any[] = [];
  public isUpdate: boolean = false;
  public mostrarListado: boolean = true;
  public alterTable: any = 'starting';
  public processing: boolean = false;
  public errors: any = {};
  private searchProcess: Subscription;

  // KPIs Dinámicos
  public kpis: any = {
    ticket_promedio: 0,
    total: 0,
    nuevos_30_dias: 0,
    nuevos_7_dias: 0
  };

  // Filtros de Búsqueda
  public searchId: string = '';
  public searchText: string = '';
  public searchSelected: any = {};
  public selected: any;

  // Paginación
  public paginate: any = {};
  public currentPage: number = 1;
  public lastPage: number = 1;
  public page: number = 1;
  public pageSize: number = 10;
  public pageAll: number = 0;

  constructor(
    private inversionistasService: InversionistasService,
    private sucursalesService: SucursalesService,
    private helperService: HelpersService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit() {
    this.getInversionistas(1);
  }

  ngOnDestroy() {
    // Cancelar cualquier petición pendiente al salir del componente
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }
  }

  /**
   * Obtiene el listado de inversionistas y los KPIs desde el servidor
   */
  public getInversionistas(page: number = 1) {
    this.processing = true;
    this.page = page;
    const filters = this.getActiveFilters();

    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    this.searchProcess = this.inversionistasService.obtenerInversionistas(page, filters)
      .subscribe(
        response => {
          this.processing = false;
          const res = response.json ? response.json() : response;
          const content = res.content || res;

          // Asignar KPIs dinámicos
          if (content.kpis) {
            this.kpis = content.kpis;
          }

          // Asignar paginación y tabla
          const paginatedData = content.data ? content.data : content;
          if (paginatedData && paginatedData.data) {
            this.inversionistas = paginatedData.data;
            this.startPaginate(paginatedData);
          } else {
            this.inversionistas = Array.isArray(paginatedData) ? paginatedData : [];
          }

          this.alterTable = (this.inversionistas.length > 0) ? false : 'not_result';
        },
        error => {
          this.processing = false;
          this.alterTable = 'not_result';
          this.helperService.httpGlobalError(error, false);
        }
      );
  }

  /**
   * Genera el objeto de filtros activos para enviar en las peticiones HTTP
   */
  private getActiveFilters() {
    return {
      page: this.page,
      limit: this.pageSize,
      id: this.searchId ? String(this.searchId).trim() : null,
      search: this.searchText ? String(this.searchText).trim() : null,
      paginate: true
    };
  }

  /**
   * Aplica la búsqueda con los filtros ingresados
   */
  public filtrar() {
    this.getInversionistas(1);
  }

  /**
   * Limpia los campos de filtro y reinicia la consulta
   */
  public borrarFiltros() {
    this.searchId = '';
    this.searchText = '';
    this.getInversionistas(1);
  }

  /**
   * Navegación
   */
  public actualizarInversionista(id: number) {
    this.router.navigate(['/inversionista/registro/', id]); 
  }

  public goPerfilInversionista(id: number) {
    this.router.navigate(['/inversiones/detalles/', id]);
  }

  // --- LÓGICA DE PAGINACIÓN ---

  public startPaginate(content: any) {
    this.paginate.first_item = content.from || 1;
    this.paginate.last_item = content.to || content.total;
    this.paginate.last_page = content.last_page || 1;
    this.paginate.per_page = content.per_page || this.pageSize;
    this.paginate.total_items = content.total || 0;
    this.paginate.current_page = content.current_page || 1;
    
    this.currentPage = content.current_page || 1;
    this.lastPage = content.last_page || 1;
    this.pageAll = content.total || 0;
    this.pageSize = content.per_page || this.pageSize;

    this.paginate.pages = [];
    for (let i = 1; i <= this.lastPage; i++) {
      this.paginate.pages.push(i);
    }
  }

  public goPage(page: number) {
    if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
      this.getInversionistas(page);
    }
  }

  public goPreviousPage() {
    if (this.currentPage > 1) {
      this.goPage(this.currentPage - 1);
    }
  }

  public goNextPage() {
    if (this.currentPage < this.lastPage) {
      this.goPage(this.currentPage + 1);
    }
  }

  public changePageSize(event: any) {
    const value = event.target ? event.target.value : event;
    this.pageSize = Number(value) || 10;
    this.getInversionistas(1);
  }

  // --- MANEJO DE ERRORES Y SELECCIONES ---

  private setBackendErrors(errors: any) {
    let temp_errors: any = {};
    if (errors && typeof errors === 'object') {
      Object.keys(errors).forEach(key => {
        temp_errors[key] = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
      });
    }
    this.errors = temp_errors;
  }

  public resetSelected() {
    this.selected = undefined;
    this.errors = {};
  }

  public startSelected() {
    this.resetSelected();
    if (typeof this.inversionistasService.getDefaultSchedule === 'function') {
      this.selected = this.inversionistasService.getDefaultSchedule(); 
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/inversiones/inversionistas.component.ts